import { call, put, takeLatest } from "redux-saga/effects";
import apiCall from "../services"
import config from '../config/config.json';

const endpoint = `${config.credentials.url}/backend-scale`;

function* getBackendScaleList(actions) {
    try {
        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${actions.access}`,
        };

        const query = actions.query ? actions.query : "";
        const url = `${endpoint}/${query}`;

        const response = yield call(
            apiCall,
            "GET",
            url,
            { headers }
        );

        yield put({
            type: "BACKEND_SCALE_LIST_RESPONSE",
            value: response,
        });

    } catch (error) {
        yield put({
            type: "BACKEND_SCALE_ERROR",
            error,
        });
    }
}

function* getBackendScaleDetail(actions) {
    try {
        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${actions.access}`,
        };

        const url = `${endpoint}/${actions.id}/`;

        const response = yield call(
            apiCall,
            "GET",
            url,
            { headers }
        );

        yield put({
            type: "BACKEND_SCALE_DETAIL_RESPONSE",
            value: response,
        });

    } catch (error) {
        yield put({
            type: "BACKEND_SCALE_ERROR",
            error,
        });
    }
}

function* createBackendScale(actions) {
    try {
        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${actions.access}`,
        };

        const requestOptions = {
            headers,
            body: JSON.stringify(actions.payload),
        };

        const response = yield call(
            apiCall,
            "POST",
            `${endpoint}/`,
            requestOptions
        );

        yield put({
            type: "BACKEND_SCALE_CREATE_RESPONSE",
            value: response,
        });
    } catch (error) {
        yield put({
            type: "BACKEND_SCALE_CREATE_ERROR",
            error,
        });
    }
}

function* updateBackendScale(actions) {
    try {
        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${actions.access}`,
        };

        const requestOptions = {
            headers,
            body: JSON.stringify(actions.payload),
        };

        const response = yield call(
            apiCall,
            "PATCH",
            `${endpoint}/${actions.id}/`,
            requestOptions
        );

        yield put({
            type: "BACKEND_SCALE_UPDATE_RESPONSE",
            value: response,
        });
    } catch (error) {
        yield put({
            type: "BACKEND_SCALE_UPDATE_ERROR",
            error,
        });
    }
}

export default function* sagaBackendScale() {
    yield takeLatest("BACKEND_SCALE_LIST_REQUEST", getBackendScaleList);
    yield takeLatest("BACKEND_SCALE_DETAIL_REQUEST", getBackendScaleDetail);
    yield takeLatest("BACKEND_SCALE_CREATE_REQUEST", createBackendScale);
    yield takeLatest("BACKEND_SCALE_UPDATE_REQUEST", updateBackendScale);
}
